module.exports = __webpack_public_path__ + "img/head.9df61ba4.png";